import { Seo } from '../components/Seo';
import { Reveal } from '../components/Reveal';
import { CtaBand } from '../components/CtaBand';
import { INSTAGRAM_TAROMANCE_URL } from '../lib/externalLinks';
import { ArrowIcon } from '../components/ArrowIcon';

const SCENES = [
  { title: '바 8석의 거리감', description: '바텐더와 리더, 그리고 옆자리 손님. 좁은 공간이 만드는 자연스러운 대화의 밀도가 타로맨스의 핵심입니다.' },
  { title: '취향이 통하는 밤', description: '판타지, 웹툰, 타로, 서브컬처. 좋아하는 것을 편하게 이야기할 수 있는 드문 공간입니다.' },
  { title: '처음이어도 단골처럼', description: '혼자 와도 어색하지 않습니다. 카드 한 장이면 누구와도 이야기가 시작됩니다.' }
];

export function NightCommunityPage() {
  return (
    <div className="tm-page">
      <Seo
        title="나이트 커뮤니티 | 타로맨스"
        description="대화와 취향이 이어지는 타로맨스의 밤. 단골과 처음 온 손님이 자연스럽게 섞이는 커뮤니티 공간입니다."
      />

      <section className="tm-page-hero">
        <div className="tm-container">
          <Reveal>
            <p className="tm-eyebrow">Night Community</p>
            <h1 className="tm-display">
              혼자 와서
              <br />
              <em>함께 있다 가는 곳</em>
            </h1>
            <p className="tm-lede">
              타로맨스의 밤은 술 소비가 아니라 경험으로 채워집니다. 대화, 리딩, 분위기 —
              그리고 그 사이에서 자연스럽게 만들어지는 사람들의 연결.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="tm-section">
        <div className="tm-container">
          <div className="tm-split--even tm-split">
            <Reveal>
              <div className="tm-figure tm-figure--tall">
                <img src="/assets/taromance/store/naver-store-01.jpg" alt="타로맨스 매장 내부" loading="lazy" />
              </div>
            </Reveal>
            <Reveal delay={100}>
              <ol className="tm-steps">
                {SCENES.map((scene, index) => (
                  <li className="tm-step" key={scene.title}>
                    <span className="tm-step-no">{String(index + 1).padStart(2, '0')}</span>
                    <div>
                      <h3 className="tm-h3">{scene.title}</h3>
                      <p className="tm-body-text">{scene.description}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="tm-section tm-section--line tm-section--deep">
        <div className="tm-container">
          <Reveal>
            <div className="tm-hub-head">
              <div>
                <p className="tm-eyebrow">News & Events</p>
                <h2 className="tm-h2">소식은 인스타그램에서</h2>
              </div>
            </div>
            <p className="tm-lede" style={{ marginTop: 0 }}>
              이벤트, 새 시그니처 칵테일, 운영 공지는 인스타그램에서 가장 먼저 알립니다.
            </p>
            <div style={{ marginTop: 28 }}>
              <a className="tm-arrow-link" href={INSTAGRAM_TAROMANCE_URL} target="_blank" rel="noreferrer">
                @taromance 팔로우하기
                <ArrowIcon />
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      <CtaBand title="오늘 밤의 자리, 미리 잡아두세요." secondaryLabel="칵테일 & 메뉴" secondaryTo="/cocktail-menu" />
    </div>
  );
}
